import { LDFlags } from '../constants/flags';
import { Country } from '../gql/generated/graphql';
import useFlag from './useFlag';

const useFlowCountry = (): Country =>
  useFlag(LDFlags.COM_CANADA_EXPERIENCE) ? Country.Ca : Country.Us;

export default useFlowCountry;
